// CREATE:
// src/components/blog/TableOfContents.jsx

import React from "react";
import useThemeMode from "../../hooks/useThemeMode";
import { getMarketingTheme } from "../../utils/marketingTheme";

function TableOfContents({ items = [] }) {
  const { isDark } = useThemeMode();
  const colors = getMarketingTheme(isDark);

  return (
    <section
      style={{
        padding: "0 20px 32px"
      }}
    >
      <div
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
          background: colors.cardBg,
          border: `1px solid ${colors.border}`,
          borderRadius: "24px",
          padding: "24px"
        }}
      >
        <h3
          style={{
            margin: "0 0 18px",
            color: colors.text,
            fontSize: "20px"
          }}
        >
          Table of contents
        </h3>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "14px"
          }}
        >
          {items.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              style={{
                color: colors.textMuted,
                textDecoration: "none",
                transition: "0.2s ease"
              }}
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TableOfContents;